import React from "react"

import PCMAdminComponent from "../components/PCMAdmin/PCMAdmin"

const PCMAdminView = () => <PCMAdminComponent />

export default PCMAdminView
